import { useTranslation } from 'react-i18next'
import { useToggleTicketConfigActiveMutation } from '@/entities/ticket-config'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { StatusToggleWithConfirm } from '@/shared/ui/status-toggle-with-confirm'

interface TicketConfigStatusToggleProps {
  configId: string
  tenantId?: string
  isActive: boolean
}

export function TicketConfigStatusToggle({
  configId,
  tenantId,
  isActive,
}: TicketConfigStatusToggleProps) {
  const { t } = useTranslation()
  const mutation = useToggleTicketConfigActiveMutation()

  return (
    <div className="flex justify-center">
      <StatusToggleWithConfirm
        checked={isActive}
        pending={mutation.isPending}
        confirmEnableTitle={t('ticketConfig.enableConfirm', {
          defaultValue: 'Activate this ticket config?',
        })}
        confirmDisableTitle={t('ticketConfig.disableConfirm', {
          defaultValue: 'Deactivate this ticket config?',
        })}
        onConfirmed={async () => {
          try {
            await mutation.mutateAsync({
              id: configId,
              ...(tenantId ? { tenantId } : {}),
              isActive: !isActive,
            })
            showToast.success(
              t('ticketConfig.statusUpdateSuccess', {
                defaultValue: 'Ticket config status updated',
              }),
            )
          } catch (error) {
            showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
          }
        }}
      />
    </div>
  )
}
